/* eslint-disable react-hooks/exhaustive-deps */
import { Select } from 'antd';
import React, { useRef, useCallback, useState } from 'react';
import './index.scss';
import { formatMilestonePlaybackTime } from './utils';

const SECONDS_IN_DAY = 86400;


export const ProgressBar = ({
  currentTime = 0,
  onSeek,
  playbackRate,
  setPlaybackRate,
  playbackRateOptions,
  showRateSelector = true,
}) => {
  const progressRef = useRef(null);
  const tooltipRef = useRef(null);
  const [hoverTime, setHoverTime] = useState('')

  const handleMouseMove = useCallback((e) => {
    if (!progressRef.current || !tooltipRef.current) return;
    const rect = progressRef.current.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const percentage = x / rect.width;
    const hoverTime = Math.floor(percentage * SECONDS_IN_DAY);
    setHoverTime(hoverTime)

    tooltipRef.current.textContent = formatMilestonePlaybackTime(hoverTime);
    tooltipRef.current.style.display = 'block';
    tooltipRef.current.style.left = `${x}px`;
  }, []);

  const handleMouseLeave = useCallback(() => {
    if (tooltipRef.current) {
      tooltipRef.current.style.display = 'none';
    }
  }, []);

  const handleClick = useCallback(
    (e) => {
      if (!progressRef.current) return;
      const rect = progressRef.current.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const percentage = x / rect.width;
      const seekTime = Math.floor(percentage * SECONDS_IN_DAY);
      onSeek(seekTime);
    },
    [onSeek]
  );

  return (
    <div className="progress-container">
      <div className="time-labels">
        {Array.from({ length: 25 }).map((_, i) => (
          <div
            key={i}
            className="time-label"
            style={{ left: `${(i / 24) * 100}%` }}
          >
            {`${i.toString().padStart(2, '0')}:00`}
          </div>
        ))}
      </div>

      <div
        className="progress-bar"
        ref={progressRef}
        onClick={handleClick}
        onMouseMove={handleMouseMove}
        onMouseLeave={handleMouseLeave}
      >
        <div
          className="progress-fill"
          style={{ width: `${(currentTime / SECONDS_IN_DAY) * 100}%` }}
        />
        <div ref={tooltipRef} className="tooltip"
          style={{
            transform: `${hoverTime > 3600 ? (hoverTime < 85000 ? 'translateX(-50%)' : 'translateX(-92%)') : 'translateX(-10%)'} `
          }}
        />
      </div>

      <div className="bottom-controls">
        <div className="current-time">{formatMilestonePlaybackTime(currentTime)}</div>
        {showRateSelector && (
          <div className="rate-selector">
            <Select
              size="small"
              options={playbackRateOptions}
              value={playbackRate}
              onChange={setPlaybackRate}
            />
          </div>
        )}
      </div>
    </div>
  );
};
